// src/styles/base.ts
import { css } from "lit";
var base = css`
  * {
    font-family: VerlagSSm, sans-serif;
    color: #141e55;
  }

  :host {
    display: block;
  }
`;

export {
  base
};
